import script from "./MyAccountTaxes.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountTaxes.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountTaxes.vue?vue&type=style&index=0&id=74f749df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f749df"]])

export default __exports__